import { Component } from '@angular/core';
import { SideNavService } from './shared/components/side-nav/side-nav.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [SideNavService],
})
export class AppComponent {
  title = 'antage-interview';
}
